var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TabelHeaderForNewOrder" },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "formData",
          attrs: {
            inline: true,
            rules: _vm.formDataRules,
            model: _vm.formData,
            "label-width": "90px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "送货单号", prop: "DELIVERY_NO" } },
            [
              _c(
                "div",
                { staticClass: "oneFormItem" },
                [
                  _c("el-input", {
                    staticClass: "cuInput",
                    attrs: { disabled: true },
                    on: { click: _vm.handleVendorInput },
                    model: {
                      value: _vm.formData.DELIVERY_NO,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "DELIVERY_NO", $$v)
                      },
                      expression: "formData.DELIVERY_NO"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商名称", prop: "VENDOR_NAME" } },
            [
              _c(
                "div",
                { staticClass: "oneFormItem" },
                [
                  _c("el-input", {
                    staticClass: "cuInput",
                    attrs: { disabled: true },
                    on: { click: _vm.handleVendorInput },
                    model: {
                      value: _vm.formData.VENDOR_NAME,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "VENDOR_NAME", $$v)
                      },
                      expression: "formData.VENDOR_NAME"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商代码", prop: "VENDOR_CODE" } },
            [
              _c(
                "div",
                { staticClass: "oneFormItem" },
                [
                  _c("el-input", {
                    staticClass: "cuInput",
                    attrs: { disabled: true },
                    on: { click: _vm.handleVendorInput },
                    model: {
                      value: _vm.formData.VENDOR_CODE,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "VENDOR_CODE", $$v)
                      },
                      expression: "formData.VENDOR_CODE"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "创建时间", prop: "CREATETIME" } },
            [
              _c("el-date-picker", {
                attrs: {
                  disabled: true,
                  type: "date",
                  placeholder: "选择日期"
                },
                model: {
                  value: _vm.formData.CREATETIME,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "CREATETIME", $$v)
                  },
                  expression: "formData.CREATETIME"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "remark", attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.isDisabled },
                model: {
                  value: _vm.formData.DESCRIPTION,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "DESCRIPTION", $$v)
                  },
                  expression: "formData.DESCRIPTION"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }